export default {
  possibleWin: {
    en: 'Possible win:',
  },
  success: {
    title: {
      en: 'Your bet has been successfully placed, you can find it in the "My bets" tab',
    },
  },
}
